module.exports = __webpack_public_path__ + "img/9788993480689.773ff38e.jpg";